export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const COURSE_DELETE_RETENTION_HOURS = 24;

export const HOUR_IN_MS = 60 * 60 * 1000;

export const PLACEHOLDER_AVATAR_BASE_URL = 'https://thispersondoesnotexist.com/random-person.jpeg';

export function placeholderAvatarUrl(seed?: string | null): string {
  if (!seed)
    return PLACEHOLDER_AVATAR_BASE_URL;

  return `${PLACEHOLDER_AVATAR_BASE_URL}?u=${encodeURIComponent(seed)}`;
}